module.exports = __webpack_public_path__ + "static/media/cooking-orange.5668c3ab.png";